import { type OptionsMap, OptionsType } from '@openx/types/options.ts';
import { useOptionsFetch } from '@openx/utils/apiHooks/generics/useOptionsFetch.tsx';
import { useTranslation } from 'react-i18next';

export type ExchangeSizeFetchResponse = {
  sizes: OptionsMap;
  isSizesLoading: boolean;
};

export function useExchangeSizeFetch(): ExchangeSizeFetchResponse {
  const { t } = useTranslation();
  const { isLoading: isSizesLoading, data: sizes } = useOptionsFetch({
    errorMessage: t('Failed to fetch Ad sizes'),
    optionType: OptionsType.EXCHANGE_SIZE_OPTIONS,
  });

  return {
    isSizesLoading,
    sizes,
  };
}
